import React, { useEffect, useMemo } from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
//import { ReactComponent as InfoIcon } from '../images/info-icon.svg'
import PageHeader from '../components/PageHeader';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, openModal, setAmount, setAmountData, setBreakpoints, setIsChecked, setPageError } from '../lib/features/amountSlice';
import { useGetAmountSelectionMutation, useSubmitAmountSelectionMutation, useGetCustomerDetailsMutation } from '../lib/services/eligibilityApi';
import { useLocation, useNavigate } from 'react-router-dom';
import CenteredPopup from '../components/popups/CenteredPopup';
import { formatCurrency } from '../lib/middleware/currencyFormatter';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent, clevertapIdentitySet } from "../lib/middleware/CtEvents";
// import { useGetCkycSearchMutation } from '../lib/services/kycApi';

function AmountApproved() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [getAmountSelection] = useGetAmountSelectionMutation();
    const [getCustomerDetails] = useGetCustomerDetailsMutation();
    // const [getCkycSearch] = useGetCkycSearchMutation();
    const [tapClick] = useTapClickMutation()
    const [submitAmountSelection, { isLoading }] = useSubmitAmountSelectionMutation()
    const { amount, isChecked, isModalOpen, pageerror, amountdata } = useSelector((state) => state.amount)
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const handleClose = () => {
        dispatch(closeModal(false));
        dispatch(setPageError(''))
    }
    const modalButtons = [
        { label: 'Close', onClick: handleClose }
    ]

    useEffect(() => {
        const getAmount = async () => {
            try {
                let jwt_token
                if (jwt) {
                    jwt_token = jwt
                    localStorage.setItem('jwt', jwt)
                } else {
                    jwt_token = localStorage.getItem('jwt')
                }
                const scrt = secret ? secret : localStorage.getItem('secret')
                const result = await getAmountSelection({ jwt_token, scrt })
                if (result.data && result.data.status === 'error') {
                    dispatch(setPageError(result.data.message))
                    dispatch(openModal())
                    if (result.data.message === 'Login expired! Please re-login.') {
                        localStorage.removeItem('jwt');
                        localStorage.removeItem('lastVisitedPage');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    }
                } else if (result.data && result.data.message === 'Login expired! Please re-login.') {
                    dispatch(setPageError(result.data.message))
                    dispatch(openModal())
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                } else if (result.error) {
                    if (result.error && result.error.data && result.error.data.message) {
                        dispatch(setPageError(result.error.data.message))
                    } else {
                        dispatch(setPageError('Please check your internet or try again later.'))
                    }
                    dispatch(openModal())
                } else {
                    //const bpArr = Array.from({ length: 4 }, (_, i) => Math.round(parseInt(result.data.approved_amount) / 4 * (i + 1)))
                    const bpArr = [];
                    for (let i = 25000; i <= parseInt(result.data.approved_amount); i += 5000) {
                        bpArr.push(i);
                    }
                    dispatch(setAmountData({ ...result.data }))
                    dispatch(setBreakpoints(bpArr))
                    dispatch(setAmount(result.data.approved_amount))
                }
            } catch (error) {
                dispatch(setPageError('Something went wrong. Please try again later.'));
                dispatch(openModal())
            }
        }
        getAmount()
    }, [dispatch, getAmountSelection, navigate, jwt, secret])

    const handleSubmitAmountSelection = async () => {
        try {
            let jwt_token
            if (jwt) {
                jwt_token = jwt
                localStorage.setItem('jwt', jwt)
            } else {
                jwt_token = localStorage.getItem('jwt')
            }
            const scrt = secret ? secret : localStorage.getItem('secret')
            const consents = [
                {
                  consent_type: "MFI_DECLARATION",
                  consent_status: isChecked ? "ACCEPTED" : "DECLINED",
                  consent_text: "I confirm that my annual household income is greater than 3 lakh."
                }
            ]
            const result = await submitAmountSelection({ jwt_token, amount, scrt, consents: JSON.stringify(consents) })
            if (result.data && result.data.status === 'error') {
                dispatch(setPageError(result.data.message))
                dispatch(openModal())
                if (result.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                }
            } else if (result.error) {
                if (result.error && result.error.data && result.error.data.message) {
                    dispatch(setPageError(result.error.data.message))
                } else {
                    dispatch(setPageError('Please check your internet or try again later.'))
                }
                dispatch(openModal())
            } else {
                if (result && result.data && result.data.redirect_url) {
                    const event_name = 'web_soft_approval_success'
                    const event_property = { Source: window.localStorage.getItem('utm_source'), segment: result.data.customer_segmentation }
                    await pushCleverTapEvent({ event_name, event_property })
                    window.location.href = result.data.redirect_url
                }
            }
        } catch (error) {
            dispatch(setPageError('Something went wrong. Please try again later.'));
            dispatch(openModal())
        }
    }

    // setting customer ID for clevertap identification.
    useEffect(() => {
        (async () => {
            let jwt_token = jwt ? jwt : localStorage.getItem('jwt');
            let scrt = secret ? secret : localStorage.getItem('secret');
            const result = await getCustomerDetails({ jwt_token, scrt });
            if(result.data?.success) {
                clevertapIdentitySet({identity: result.data?.data?.id});
            }
            if(result.error) {
               console.log(`customer_details_error <<${result.error.data.error_message}>> || error_code <<${result.error.data.error_code}>>`);
            }
        })()
    }, [])

    return (
        <div className='external-wrapper amount-page amount-approved'>
            <CenteredPopup
                isOpen={isModalOpen}
                buttons={modalButtons}
                onClose={handleClose} icon={<WarningIcon />}>
                <p>{pageerror}</p>
            </CenteredPopup>
            <div className={`page-content ${!localStorage.getItem('customerSegment') || (localStorage.getItem('customerSegment') && localStorage.getItem('customerSegment').toLowerCase() === 'a3-a6') ? 'spaced-content' : ''}`}>
                <PageHeader />
                {/*<div className='page-heading'>
                    <h2 className='page-title'>Select the required amount</h2>
                </div>*/}
                <div className='amount-section approved-amount'>
                    <h3>Approved!</h3>
                    <p>You are eligible for a Personal Loan up to</p>{/*(localStorage.getItem('customerSegment') && localStorage.getItem('customerSegment').toLowerCase() === 'a3-a4') ? '' : null*/}
                    <div className='loan-amount'>
                        <div className='amount'><span className='pe-0'>₹ </span><span>{amount ? formatCurrency(Number(amount)) : '0'}</span></div>
                    </div>
                </div>
                <div className='bottom-footer p-0'>
                    <div className='consent-check'><label><div className={`checkbox ${isChecked ? 'checked' : ''}`}><input type="checkbox" checked={isChecked} onChange={() => dispatch(setIsChecked(!isChecked))} /></div> <p>I confirm that my annual household income is greater than 3 lakh.</p></label></div>
                    <p className='powered-by'>Powered by <StarfinLogo /></p>
                    <button type="button" onClick={
                        () => {
                            //localStorage.setItem("lastVisitedPage", '/complete-your-kyc')
                            //navigate('/complete-your-kyc')
                            handleSubmitAmountSelection()
                        }
                    } className={`btn btn-primary ${!isChecked || isLoading ? 'disabled' : ''}`}>Continue</button>
                </div>
            </div>
        </div >
    );
}

export default AmountApproved;
